import type { UiStrings } from '../types'

const ja: UiStrings = {
  brand: 'ホールカード EX',
  docTitleSuffix: '過程記録',
  tagline: '席・ホール・ボード・ラインの過程記録 — 共有用カード',
  metaDescription: 'ホールカード EX — モバイル向けポーカー過程記録。席・ホール・ボード・ストリートアクションを共有カードに。',
  stepsAria: 'ステップ',
  prev: '戻る',
  undo: '元に戻す',
  next: '次へ',
  nextSummary: 'サマリーを見る',
  privacyLink: 'プライバシー・広告ポリシー',
  privacyTitle: 'プライバシー・広告ポリシー',
  privacyHint:
    'AdSense審査向けの下書きです。本番前に内容を確認・更新してください。',
  privacyBack: 'アプリに戻る',
  privacyCollectTitle: '1. 収集する情報',
  privacyCollectBody:
    '現在ホールカード EXはハンドレビュー下書きをブラウザ内でのみ組み立てます。ログイン不要で、入力したハンド情報はサーバーへ送信しません。下書きはこのタブのsessionStorageに一時保存される場合があります（将来機能追加時に本ポリシーを更新します）。',
  privacyAdsTitle: '2. Cookie・広告',
  privacyAdsBody:
    'Google AdSenseなど第三者広告ネットワークが使用される場合があります。広告事業者はCookie・端末識別子を使い興味関心広告を表示することがあります。ブラウザ設定またはGoogle広告設定でカスタム広告を制御できます。',
  privacyContactTitle: '3. お問い合わせ',
  privacyContactBody:
    'ポリシーに関するお問い合わせは holdcard-ex.com の GitHub Issue へ。運営者メール: プロジェクト設定の TODO_OPERATOR_EMAIL。',
  langAria: '言語',
  langCompactAria: '言語（短縮）',
  koPathLink: '한국어',
  koPathLinkAria: '韓国語版 (/ko)',
  enPathLink: 'English',
  enPathLinkAria: '英語版 (/)',

  setupTitle: 'テーブル',
  setupHint: '人数・スタック・ブラインド — 続けてシート → ハンド → ライン',
  players: '人数',
  playersUnit: (n) => `${n}人`,
  sb: 'SB',
  bb: 'BB',
  ante: 'アンティ（任意）',
  anteHint: 'ブラインドと同じ単位',
  effectiveStack: '有効スタック（BB・任意）',
  potBb: 'ポット（BB・任意）',
  metaOptionalHint: 'アンティ・有効スタック・ポットは空ならサマリーに出しません',
  setupDetailsToggle: '人数・アンティ・有効・ポット・チップ',
  setupBasicsHint: '基本(6max・100bb)なら次へ、またはスキップ',
  setupMetaSetChip: 'アンティ・eff・ポット設定済',
  stackUnit: 'スタック単位',
  stackUnitBb: 'BB',
  stackUnitChips: 'チップ',
  stackChips: 'スタック（チップ）',
  stackBb: 'スタック（BB）',
  stackChipsUnit: 'チップ',

  positionTitle: 'シート',
  seatQuestion: 'どこに座っていた？',
  settingsBack: '戻る',
  settingsSegAria: 'テーブル設定（人数・ブラインド・スタック）',
  lineSeatEditAria: 'シートを直す',
  lineHoleEditAria: 'ホールカードを直す',
  positionHint: (count, hint) =>
    `${count}マックス基準${hint ? ` · ${hint}` : ''}`,

  tableVizAria: (n) => `${n}人テーブルのシート`,
  tableVizHeroBadge: '自分',
  tableVizHeroSeatAria: (seat) => `${seat}（自分）`,
  tableVizDealer: 'D',
  tableVizDealerTitle: 'ディーラーボタン',
  tableVizTapHint: 'テーブルで自分のシートをタップ',
  tableVizListFallback: 'シート一覧 · コード',
  tableVizBlindsAria: (v) => `ブラインド ${v}`,
  tableVizPotPlaceholder: 'ポット',
  tableVizPotValue: (v) => `ポット ${v}`,
  tableVizPotAria: (v) => `ポット ${v}`,
  tableVizStackAria: (v) => `スタック ${v}`,
  tableVizEmptyMark: '—',
  tableVizEffHint: (v) => `有効 ${v}bb`,
  tableVizEffTitle: '有効スタック（テーブル共通・座席別ではない）',
  tableVizStepDown: '減らす',
  tableVizStepUp: '増やす',
  tableVizEditDone: '完了',
  tableVizInfoHint: 'テーブルのブラインド・ポット・スタックをタップして編集',
  seatAbbrevHint: '座席は略称です。タップで正式名が出ます。',

  cardsTitle: 'ハンド',
  cardsHint: '自分のカードから · 相手は「相手も入力」で · スロット・スート・ランク · 重複不可',
  heroHolesGuide: (seat) => `${seat}のホールカードを2枚選んでください。`,
  cardSlot1: 'カード1',
  cardSlot2: 'カード2',
  cardSlotSelect: '選択',
  seatsLabel: '座席',
  knownHolesOptional: '相手のホールカードは任意です（ショーダウン・レビュー用 · 空でもOK）',
  holesBySeat: 'ホールカード · 座席選択',
  seatVillain: (pos) => `ヴィラン ${pos}`,
  seatFilled: '入力済',
  holesModeHeroOnly: '自分だけ',
  holesModeWithVillains: '相手も入力',
  holesModeAria: 'ホールカード入力モード',
  villainNudgeToast: '相手のカードが分かれば BB などをタップ',
  heroCardsDoneCta: 'ラインへ',
  heroCardsAddVillainsCta: '相手も入力',
  suitPickerLabel: 'スート',
  rankPickerLabel: 'ランク',

  boardTitle: 'ボード',
  boardHint: '来たときに入力 — プリフロップのみならスキップ',
  flop: 'フロップ',
  turn: 'ターン',
  river: 'リバー',
  flopSlot: (i) => `F${i}`,

  actionsTitle: 'ライン',
  actionsHint: 'ストリートごとのアクションライン — フォールド/チェック/コール/ベット/レイズ/オールイン',
  actorQuick: 'アクター簡易選択',
  actor: 'アクター',
  actorPlaceholder: '名前を入力',
  actorCustomToggle: '直接入力',
  actorRequired: 'アクターを入力または選択してください',
  action: 'アクション',
  sizeLabel: 'サイズ',
  sizePlaceholder: '例: 2.5bb',
  sizeRequired: 'ベット/レイズのサイズを入力してください',
  sizeCustomToggle: '直接入力',
  sizeOpenApprox: 'オープン',
  sizePotApprox: 'ポットサイズ',
  sizeOverbetApprox: 'オーバーベット',
  sizeJamApprox: 'ショート / jam',
  sizeUnitBb: 'bb',
  sizeUnitPct: 'pot',
  snapHint: '目盛りにスナップ · ±で1目盛り',
  favoritesLabel: 'よく使う',
  morePresets: 'その他のプリセット',
  presetsSizeLabel: 'プリセット · サイズ',
  potSizeHintUnset: 'セットアップでポット(BB)を入れるとポットサイズがbbで見えます',
  clearOptional: 'なし',
  betRaiseHint: 'ベット: まだ攻撃がない時 · レイズ: ベット/レイズに対して',
  allinSizeHint: 'オールインサイズ（任意）',
  sizeActionHint: (potBit) =>
    potBit
      ? `ベット=先攻 · レイズ=対応 · ${potBit}`
      : 'ベット=先攻 · レイズ=対応',
  addAction: (street) => `${street}アクション追加`,
  updateAction: '更新を適用',
  editAction: '編集',
  cancelEdit: '編集キャンセル',
  noStreetActions: (street) => `${street}の記録がありません。`,
  delete: '削除',
  moveUp: '上へ',
  moveDown: '下へ',
  allActionsHint: (n) => `全${n}件 · 他ストリートタブで確認`,
  heroChip: (pos) => pos,
  seatOrderHu: 'HU: BTNがSB役 · 順 BTN/SB → BB',
  seatOrder: (order) => `座席順: ${order}`,
  positionHintHuBtn: 'HUボタン（SB）',
  keepActorHint: 'ストリート切替でもアクターを維持（タイプ・サイズのみリセット）',
  potQuickPrompt: 'ポット(BB)クイック — タップで設定しヒント更新',
  potQuickClear: 'ポット消去',
  quickLinesLabel: 'クイックライン',
  quickLinesHint: 'よく使うテンプレ · タップでアクション追加',
  macroOpenThenCall: 'オープン後コール',
  macroFoldToHero: (seat) => `${seat}までフォールド`,
  macroCbet33: 'C-bet ⅓ pot',
  quickLinesSwitchStreet: 'ストリートを切り替えるとマクロが表示されます',
  macroOpenExists: 'すでにオープン（レイズ）が記録されています',
  macroAlreadyLogged: 'オープンとコールはすでに記録されています',
  macroFoldToHeroNone: (seat) => `前のフォールドはありません（${seat}が先頭）`,
  macroFoldToHeroBlocked: '前にアクションあり — フォールドは手動で追加',
  boardCtaFlop: 'フロップを追加',
  boardCtaTurn: 'ターンを追加',
  boardCtaRiver: 'リバーを追加',
  quickHand: 'クイックハンド',
  skipToCards: 'カードから始める',
  jumpToActions: 'ラインへ',
  skipBoardPreflop: 'ボードをスキップ — プリフロップのみ',
  boardSlotsToggle: 'ボードを入れる',
  softStackAria: 'ここまでのハンド',
  softStackLine: 'ライン',
  softStackHoles: 'ホール',
  softStackBoard: 'ボード',
  streetTabWithCount: (street, n) => `${street} · ${n}`,
  actionIndexLabel: (n, street) => `アクション ${n} · ${street}`,
  copyLinkTitle: 'アプリでこのハンドを再度開きます',
  suitStickyHint: 'スート維持中 · タップで変更',
  suitStickyChip: (s) => `現在のスート ${s}`,
  suitMruLabel: '最近',

  summaryHint:
    '下の過程カードをスクリーンショットするか、テキストをコピー・共有',
  summaryHole: 'ホールカード',
  summaryBoard: 'ボード',
  summaryActions: 'アクション',
  timelineProcess: 'プロセス',
  timelineBoard: (cards) => `ボード ${cards}`,
  processMoreSummary: '過程をもっと見る',
  linePeekSummary: 'これまでのライン',
  takeawayLabel: '一言',
  takeawayPlaceholder: '席とラインだけ — 例: BTNレイズ後BBコール、フロップチェック',
  takeawayHint: '過程の一行 — 席とラインだけ',
  takeawayNudge: '過程を一行（任意）\u00a0· 席・ライン',
  takeawayInLinkFact: '過程の一行はリンクに入ります',
  shareSecondarySummary: 'メモ・相手（任意）',
  shareSecondaryInvite: '過程の一行を残す（任意）',
  shareMoreSummary: 'ほかの共有',
  lineDraftSummary: 'アクター・サイズ',
  explainModeLabel: '説明',
  explainModeAria: '説明モード — 学習ヒントを表示',
  reviewScopeLabel: 'ここまでレビュー',
  reviewScopePreflop: 'プリフロップ',
  reviewScopeFlop: 'フロップ',
  reviewScopeRiver: 'リバー',
  reviewScopeAria: 'レビュー範囲 — 以降ストリートは折りたたみ（削除しない）',
  shareProcessHu: 'ヘッズアップ',
  shareProcessMultiway: 'マルチウェイ',
  shareReviewedLabel: 'レビュー時刻',
  summaryCopyLabel: 'チャットに貼り付け — 読みやすい + Pro',
  summaryProLabel: 'Pro notation',
  emptyDash: '—',
  copyBoth: 'チャットに共有',
  copyHuman: '読みやすい',
  copyPro: 'Pro表記',
  copied: 'コピー済み ✓',
  copiedToast: 'サマリーをコピーしました',
  screenshotHint: 'キャプチャ = きれいなカードショット · リンク = ハンドを再度開く',
  captureMode: 'キャプチャ',
  captureExit: 'キャプチャ終了',
  saveShareImage: '画像を保存',
  shareImage: '画像を共有',
  imageSaved: '保存済み ✓',
  imageShared: '共有済み ✓',
  imageSavedToast: '画像を保存しました',
  imageSharedToast: '画像を共有しました',
  imageFailedToast: '画像を作成できませんでした',
  shareText: 'テキスト共有',
  shared: '共有済み ✓',
  copyLink: 'リンクをコピー',
  linkCopiedToast: 'ハンドリンクをコピーしました',
  linkWithoutKnownHolesToast:
    'リンクが長いためヴィランのホールカードを除いてコピーしました',
  linkTooLongToast: 'ハンドが長くてリンクを作れません',
  sharedToast: '共有しました',
  shareFailedToast: '共有に失敗しました',
  newHand: '新しいハンド',
  receivedQuietRerecordCta: 'この過程で自分も記録',
  draftRestoredHint: '下書きを復元しました — 続けるか新規にしますか？',
  draftContinue: '続ける',
  actorFoldedHint: 'フォールド済み',
  summaryHeading: '[ホールカード EX ハンドサマリー]',
  summaryPlayers: (n) => `人数: ${n}人`,
  summaryBlinds: (b) => `ブラインド: ${b}`,
  summaryHero: (p) => `席: ${p}`,
  summaryStack: (s) => `スタック: ${s}`,
  summaryEff: (e) => `有効スタック: ${e} BB`,
  summaryPot: (p) => `ポット: ${p} BB`,
  summaryHoleLine: (h) => `ホール: ${h}`,
  summaryHolesHeader: 'ホール:',
  summaryKnownHoleLine: (label, cards) => `· ${label}: ${cards}`,
  summaryBoardLine: (b) => `ボード: ${b}`,
  summaryActionsHeader: '── アクション ──',
  summaryFooter: '— ホールカード EX で作成',
  summaryProHeader: '── Pro notation ──',
  tableLine: (n, blinds) => `${n}人 · ${blinds}`,

  errorBlinds:
    'ブラインドが無効です。BBは0より大きく、SBは0以上かつBB以下である必要があります。',
  hintFlopPartial: 'フロップは通常3枚です',
  hintNoActions: 'アクションなしでも大丈夫 — 「記録を終える」でここまでの記録を共有します',
  missingFlopBoard: 'フロップアクションがあるのにボードのフロップがありません',
  missingTurnBoard: 'ターンアクションがあるのにターンカードがありません',
  missingRiverBoard: 'リバーアクションがあるのにリバーカードがありません',
  boardActionsMismatch: 'ボードカードが空のストリートにアクションがあります',
  boardNeedFlop: 'フロップボードが空です — カード追加を推奨',
  boardNeedFlopPartial: 'フロップカードの残りを入力してください',
  boardNeedTurn: 'ターンカードが空です — カード追加を推奨',
  boardNeedRiver: 'リバーカードが空です — カード追加を推奨',

  softGateTitle: 'まだ空の項目があります',
  softGateBody: 'ホールカードがまだ空です。ホールを追加して過程を残すか、そのまま続行できます。',
  softGateFix: "ホールカードを追加",
  softGateForceConfirm: "未完成のまま共有しますか？",
  softGateMissingHoles: (seat) => `${seat}のホールカード（2枚）`,
  softGateMissingActions: "少なくとも1つのアクション",
  softGateBodyLead: "まだ必要なもの:",
  incompleteBadge: "未完成",
  softGateContinue: 'それでもサマリーを見る',
  softGateShare: 'それでも共有',
  softGateCopy: 'それでもコピー',
  softGateCancel: '戻る',
  pickerDisabled: '選択スロットがありません',

  step: {
    setup: 'テーブル',
    position: 'シート',
    cards: 'ハンド',
    board: 'ボード',
    actions: 'ライン',
    summary: '共有',
  },
  street: {
    preflop: 'プリフロップ',
    flop: 'フロップ',
    turn: 'ターン',
    river: 'リバー',
  },
  actionType: {
    fold: 'フォールド',
    check: 'チェック',
    call: 'コール',
    bet: 'ベット',
    raise: 'レイズ',
    allin: 'オールイン',
  },
  suit: {
    s: 'スペード',
    h: 'ハート',
    d: 'ダイヤ',
    c: 'クラブ',
  },
  positionHintMap: {
    UTG: 'アンダーザガン',
    'UTG+1': 'UTG+1',
    MP: 'ミドル',
    'MP+1': 'MP+1',
    HJ: 'ハイジャック',
    CO: 'カットオフ',
    BTN: 'ボタン（ディーラー）',
    SB: 'スモールブラインド',
    BB: 'ビッグブラインド',
  },

  progressAria: (current, total, label) =>
    `${total}ステップ中 ${current}ステップ目: ${label}`,
  adArea: '広告枠',
  adTop: '上部広告枠',
  adBottom: '下部広告枠',
  adPlaceholderHint: 'AdSense ID未設定 — デプロイ前プレースホルダー',
  // Softwise M10b: memory-order input
  endHere: "ここで終了",
  finishRecord: "記録を終える",
  reviewAnte: (v) => `アンティ ${v}`,
  reviewEffStack: (v) => `有効 ${v}`,
  reviewBreakdownAria: 'ストリート別',
  reviewPlayers: (n) => `${n}人`,
  // vocab-tags:start — screen-only poker vocabulary (review breakdown) (v1 — pending native-player review)
  reviewVocab: {
    trips: 'トリップス',
    paired: 'ペアボード',
    monotone: 'モノトーン',
    twoTone: 'ツートーン',
    rainbow: 'レインボー',
    limp: 'リンプ',
    open: 'オープン',
    threeBet: '3ベット',
    fourBet: '4ベット',
    fiveBet: '5ベット',
    squeeze: 'スクイーズ',
    coldCall: 'コールドコール',
    checkRaise: 'チェックレイズ',
    cBet: 'Cベット',
    donkBet: 'ドンクベット',
    probeBet: 'プローブベット',
  },
  shareSavedMark: '保存済み',
  // vocab-tags:end
  flowAskFlop: "フロップ 3枚",
  flowAskTurn: "ターン 1枚",
  flowAskRiver: "リバー 1枚",
  flowWhoActs: "手番",
  flowSizeCustom: "直接",
  flowSizeConfirm: "確認",
  flowSizeLabel: "サイズ (bb)",
  flowDone: "ライン記録済み",
  flowRewind: "ここからやり直す",
  flowRewindCancel: "キャンセル",
  flowSeatUnrecorded: "記録なし",
  flowSeatNotInvolved: "不参加",
  flowMemoryCut: "ここから先は覚えていない",
  lineStripAria: "これまでのライン",
  // Soft G: optional ending record (L1.5) — seat-subject, press-only, Quiet
  endingSummary: '結末（任意）',
  endingShownLabel: 'ショーダウンで見せたカード',
  endingPotLabel: 'ポット',
  endingCardsInput: 'カード入力',
  endingMuck: '見せず（マック）',
  endingUnknown: '不明',
  endingPotTo: (seat) => `${seat} ポット獲得`,
  endingSplit: 'スプリット',
  endingLineLabel: '結末',
  endingShownCards: (seat, cards) => `${seat} ${cards} を見せた`,
  endingShownMuck: (seat) => `${seat} 見せず（マック）`,
  endingShownUnknown: (seat) => `${seat} カード不明`,
  endingPotSplit: 'ポットはスプリット',
  endingPotUnknown: 'ポット不明',
  linkWithoutEndingToast: 'リンクが長いため結末を省いてコピーしました',
  linkWithoutTakeawayToast: 'リンクが長いため過程の一行を省いてコピーしました',
  endingShownAria: (seat) => `${seat} ショーダウンのカード`,
}

export default ja
